;(function ($) {
	let loaderGif = $("#loader-gif");
	let resetFilter = false;
	
	$(document).ready(function () {
		
		$('#filter-form input:not(input[type=text]), #filter-form select').on('change', function () {
			let form = $('#filter-form').get(0);
			if ($(form).find('button.submit-filter-btn').length > 0)
				return false;
			
			filterForm(false,form);
		});
		
		$('#filter-form .filter-btn button').on('click', function (e) {
			e.preventDefault();
			
			let form = $('#filter-form').get(0);
			resetFilter = $(this).data('action') === 'reset';
			
			filterForm(false,form, $(this).data('action') === 'reset');
		});
		
		$('.range').map((key, value) => {
			let minValue = $(value).attr('data-min');
			let maxValue = $(value).attr('data-max');
			
			globalRange(minValue, maxValue, $(value).attr('id'));
		});
		
		$(document).on('change', '#sort-form select', function () {
			let form = $('#filter-form').get(0);
			let $this = $(this);
			filterForm($this,form);
		});
		
	});
	
	
	function globalRange(min, max, itemId) {
		let form = $('#filter-form').get(0);
		let slider = $('#' + itemId).get(0);
		let fromFieldId = itemId.replace('-range', '') + '-from';
		let toFieldId = itemId.replace('-range', '') + '-to';
		let fieldFrom = $(slider).siblings('.range-values').find('#' + fromFieldId);
		let fieldTo = $(slider).siblings('.range-values').find('#' + toFieldId);
		let fieldFromVal = fieldFrom.val();
		let fieldToVal = fieldTo.val();
		
		
		if (min === max)
			min = max - 1;
		
		if (fieldFromVal === fieldToVal)
			fieldFromVal = fieldToVal - 1;
		
		let minVal = min === fieldFromVal ? min : fieldFromVal;
		let maxVal = max === fieldToVal ? max : fieldToVal;
		
		noUiSlider.create(slider, {
			start: [Math.floor(minVal), Math.ceil(maxVal)],
			connect: true,
			margin: 1,
			range: {
				'min': Math.floor(min),
				'max': Math.ceil(max)
			}
		});
		
		slider.noUiSlider.on('update', function (values, handle) {
			handle ? fieldTo.val(Math.ceil(values[handle])) : fieldFrom.val(Math.floor(values[handle]));
		});
		
		fieldFrom.get(0).addEventListener('change', function () {
			slider.noUiSlider.set([this.value, null]);
		});
		
		fieldTo.get(0).addEventListener('change', function () {
			slider.noUiSlider.set([null, this.value]);
		});
		
		slider.noUiSlider.on('set', function (values, handle) {
			
			if ($(form).find('button.submit-filter-btn').length > 0)
				return false;
			
			if (!resetFilter)
				filterForm(false,form);
		});
		
	}
	
	
	function filterForm($this = false,parentThat, resetForm) {
		
		let formId = $(parentThat).attr('id');
		let form = $('#' + formId);
		let sortForm = $('#sort-form');
		
		if (form.length < 1) {
			return;
		}
		
		form.submit(function (event) {
			event.preventDefault();
		});
		
		let serializedForm = $(form).find("select, input").serializeArray();
		
		let serializedSortForm = [];
		
		if(sortForm.length > 0)
			serializedSortForm = sortForm.find('select').serializeArray();
		
		if(serializedSortForm.length > 0)
			serializedSortForm.map((value) => {
				
				if ( value.name ==  'sort-per-page'){
					
					var $value =  $($this).find('option:selected').val();
					
					if (!$value){
						var url_string = window.location.href;
						var url = new URL(url_string);
						var c = url.searchParams.get("sort-per-page");
						
						serializedForm.push({name: value.name, value: c});
						
					}else{
						serializedForm.push({name: value.name, value: $value});
					}
					
				}else{
					serializedForm.push({name: value.name, value: value.value});
				}
				
			});
		
		if (resetForm)
			if (serializedForm.length > 0)
				serializedForm = serializedForm.filter(function (item) {
					return item.name === 'categoryId';
				});
		
		$.ajax({
			method: "POST",
			url: form.attr('action'),
			beforeSend: function () {
				loaderGif.fadeIn();
			},
			data: serializedForm,
			success: function (response) {
				loaderGif.fadeOut();
				
				if (response.status) {
					
					let pushUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + response.pushUrl;
					window.history.pushState({path: pushUrl}, '', pushUrl);
					
					if (response.view && $(document).find('.products-list').length > 0) {
						$(document).find('.products-list').html(response.view);
						$(document).find('.sort-block').html(response.sort_block);
					}
					
					if (resetForm) {
						
						form.find('input[type=checkbox]').prop('checked', false);
						form.find('input[type=radio]').prop('checked', false);
						let formRanges = form.find('.range');
						
						if (formRanges.length > 0)
							formRanges.map((key, value) => {
								$(value).siblings('.range-values').find('.range-min input').val($(value).data('min'));
								$(value).siblings('.range-values').find('.range-max input').val($(value).data('max'));
								
								let slider = $('#' + $(value).attr('id')).get(0);
								slider.noUiSlider.updateOptions({
									start: [Math.floor($(value).data('min')), Math.ceil($(value).data('max'))]
								});
							});
						
						resetFilter = false;
					}
					
				}
			},
			error: function () {
				loaderGif.fadeOut();
			}
		})
		
	}
	
	window.addEventListener('popstate', function (e) {
		
		if (e.state === null) {
			window.location.href = window.location.protocol + "//" + window.location.host + window.location.pathname;
		} else {
			window.location.href = e.state.path;
		}
		
	});
	
})
(jQuery);